const InteractivePageCards = (block) => {
    if (!block) {
        return;
    }

    const cards = block.querySelectorAll('.interactive-page-card');

    if (!cards.length) {
        return;
    }

    const desktop = window.matchMedia('(min-width: 1025px)');

    const setClosedHeight = (card) => {
        if (!desktop.matches) {
            return;
        }

        const body = card.querySelector('.interactive-page-card__body');
        const title = card.querySelector('.interactive-page-card__title');

        if (!body || !title) {
            return;
        }

        body.style.height = `${title.offsetHeight}px`;
    };

    const setOpenHeight = (card) => {
        if (!desktop.matches) {
            return;
        }

        const body = card.querySelector('.interactive-page-card__body');

        if (!body) {
            return;
        }

        body.style.height = `${card.offsetHeight}px`;
    };

    const clearHeight = (card) => {
        const body = card.querySelector('.interactive-page-card__body');

        if (!body) {
            return;
        }

        body.style.height = '';
    };

    const openCard = (card, updateHash = true) => {
        cards.forEach((item) => {
            if (item !== card) {
                item.classList.remove('is-active');
                item.setAttribute('aria-expanded', 'false');

                if (desktop.matches) {
                    setClosedHeight(item);
                } else {
                    clearHeight(item);
                }
            }
        });

        if (desktop.matches) {
            /*
             * Set the current closed height first.
             */
            setClosedHeight(card);
        }

        card.classList.add('is-active');
        card.setAttribute('aria-expanded', 'true');

        if (desktop.matches) {
            /*
             * Animate from the title height to the full
             * card height.
             */
            requestAnimationFrame(() => {
                setOpenHeight(card);
            });
        }

        if (updateHash && card.id) {
            history.replaceState(null, '', `#${card.id}`);
        }
    };

    const closeCard = (card, updateHash = true) => {
        const body = card.querySelector('.interactive-page-card__body');
        const title = card.querySelector('.interactive-page-card__title');

        if (!body || !title) {
            return;
        }

        if (desktop.matches) {
            /*
             * Start from the current height.
             */
            body.style.height = `${body.offsetHeight}px`;

            requestAnimationFrame(() => {
                card.classList.remove('is-active');

                body.style.height = `${title.offsetHeight}px`;
            });
        } else {
            card.classList.remove('is-active');
            clearHeight(card);
        }

        card.setAttribute('aria-expanded', 'false');

        if (updateHash && window.location.hash === `#${card.id}`) {
            history.replaceState(
                null,
                '',
                `${window.location.pathname}${window.location.search}`
            );
        }
    };

    const toggleCard = (card) => {
        const isActive = card.classList.contains('is-active');

        if (isActive) {
            closeCard(card);
        } else {
            openCard(card);
        }
    };

    cards.forEach((card) => {
        /*
         * Set the initial closed height on desktop only.
         */
        setClosedHeight(card);

        card.addEventListener('click', (event) => {
            /*
             * Don't toggle the card when clicking an actual
             * link/button inside the card.
             */
            if (event.target.closest('a, button')) {
                return;
            }

            toggleCard(card);
        });

        card.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                toggleCard(card);
            }
        });
    });

    const openCardFromHash = () => {
        const hash = window.location.hash.substring(1);

        if (!hash) {
            return;
        }

        const card = document.getElementById(hash);

        if (!card || !block.contains(card)) {
            return;
        }

        openCard(card, false);

        requestAnimationFrame(() => {
            card.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        });
    };

    openCardFromHash();

    window.addEventListener('hashchange', openCardFromHash);

    /*
     * Handle switching between mobile and desktop.
     */
    desktop.addEventListener('change', (event) => {
        cards.forEach((card) => {
            if (event.matches) {
                setClosedHeight(card);

                if (card.classList.contains('is-active')) {
                    setOpenHeight(card);
                }
            } else {
                clearHeight(card);
            }
        });
    });

    /*
     * Recalculate closed card heights if the viewport changes.
     */
    window.addEventListener('resize', () => {
        if (!desktop.matches) {
            return;
        }

        cards.forEach((card) => {
            if (!card.classList.contains('is-active')) {
                setClosedHeight(card);
            }
        });
    });
};

export default InteractivePageCards;